import { useMxFieldControllerContext } from "../../../../context/MxFieldController";
import MxInputField, {
  MxInputFieldProps
} from "@rf-l1/form/text-fields/MxInputField";

export type MxFormInputFieldProps = Omit<MxInputFieldProps, "name">;

const MxFormInputField = (props: MxFormInputFieldProps) => {
  const { onBlur, onChange, inputRef, name, value, invalid, required, id } =
    useMxFieldControllerContext();
  const handleBlur = (evt: React.FocusEvent<HTMLInputElement>) => {
    // console.log(evt)
    // if (props.onBlur) {
    //   props.onBlur(evt);
    // }
    // onBlur(evt);
  };

  return (
    <MxInputField
      {...props}
      inputRef={inputRef}
      onChange={onChange}
      onBlur={handleBlur}
      name={name}
      value={value}
      error={invalid}
      required={required}
      id={id}
    />
  );
};

export default MxFormInputField;
